import React from 'react';

const About: React.FC = () => {
  return (
    <div style={{ maxWidth: '800px', margin: '0 auto', padding: '20px' }}>
      <h1>About AICEO</h1>
      
      <section style={{ marginBottom: '2rem' }}>
        <h2>Our Mission</h2>
        <p>
          At AICEO, we're on a mission to revolutionize how entertainment businesses are discovered, 
          analyzed, and optimized. We believe that data-driven decision making should be accessible 
          to entrepreneurs at every stage of their journey, from franchise discovery to location 
          optimization and financing.
        </p>
      </section>
      
      <section style={{ marginBottom: '2rem' }}>
        <h2>Who We Are</h2>
        <p>
          AICEO is a team of passionate entrepreneurs, data scientists, and industry experts who 
          understand the unique challenges of the entertainment business sector. We've combined our 
          expertise in artificial intelligence, location analytics, and business development to create 
          a platform that serves as your AI co-founder.
        </p>
        <p>
          Founded in 2024, our company has quickly grown to become a trusted partner for entertainment 
          business owners across the United States, helping them make smarter decisions about where to 
          open new locations, how to optimize existing ones, and how to secure the right financing.
        </p>
      </section>
      
      <section style={{ marginBottom: '2rem' }}>
        <h2>What We Do</h2>
        <p>
          Our AI-powered platform provides comprehensive location intelligence for entertainment 
          businesses, including:
        </p>
        <ul>
          <li>Demographic analysis to understand your target market</li>
          <li>Market potential assessment to forecast revenue</li>
          <li>Competitive landscape mapping to identify opportunities</li>
          <li>Foot traffic analysis to optimize visibility and accessibility</li>
          <li>Safety and crime analysis to ensure secure environments</li>
          <li>Financing options tailored to your business needs</li>
        </ul>
      </section>
      
      <section style={{ marginBottom: '2rem' }}>
        <h2>Industries We Serve</h2>
        <p>
          We specialize in helping entrepreneurs in various entertainment sectors, including:
        </p>
        <ul>
          <li>Family Entertainment Centers</li>
          <li>Bowling Alleys</li>
          <li>Arcade and Gaming Centers</li>
          <li>Trampoline Parks</li>
          <li>Indoor Adventure Parks</li>
          <li>Laser Tag Facilities</li>
          <li>Escape Rooms</li>
          <li>And more!</li>
        </ul>
      </section>
      
      <section>
        <h2>Our Values</h2>
        <ul>
          <li><strong>Data-Driven Excellence:</strong> We believe in making decisions based on comprehensive data analysis, not guesswork.</li>
          <li><strong>Entrepreneurial Empowerment:</strong> We're committed to giving business owners the tools they need to succeed.</li>
          <li><strong>Continuous Innovation:</strong> We constantly improve our AI models and analytics to provide the most accurate insights.</li>
          <li><strong>Customer Success:</strong> Your success is our success. We measure our performance by the outcomes we help you achieve.</li>
          <li><strong>Accessibility:</strong> We make sophisticated analytics accessible to businesses of all sizes.</li>
        </ul>
      </section>
      
      <section style={{ marginTop: '2rem' }}>
        <p>
          Ready to partner with your AI co-founder? <a href="/login" style={{ color: '#7FE7D9', textDecoration: 'none' }}>Get started today</a>.
        </p>
      </section>
    </div>
  );
};

export default About;
